import React from 'react'
import { Observer } from 'mobx-react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

// Routes
import Login from 'src/routes/Login'
import Main from 'src/routes/Main'
import withAuth from 'src/components/withAuth'
import UnauthorizedPage from 'src/routes/UnauthorizedPage'
import { authenticatedUserStore } from 'src/stores'

class App extends React.Component {
    render() {
        return (
            <Observer>
                {() => {
                    // access the permissions here so that the page is re-rendered
                    // if the token changes (via impersonating)
                    // eslint-disable-next-line
                    let permissions = authenticatedUserStore.permissions
                    return (
                        <Router>
                            <Switch>
                                <Route exact path="/login" component={Login} />
                                <Route
                                    exact
                                    path={'/unauthorized'}
                                    component={UnauthorizedPage}
                                />
                                <Route path="/" component={withAuth(Main)} />
                            </Switch>
                        </Router>
                    )
                }}
            </Observer>
        )
    }
}

export default App
